import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import IconView from "../IconView/IconView";

import EgwWebFont from "../../assets/EgwWebFont";
import { ARROW_ICON_DIRECTION } from "./constants";

import styles from "./arrow-icon.module.scss";

const ArrowIcon = ({ onClick, direction, variant, className, size }) => {
  return (
    <IconView
      onClick={onClick}
      className={classNames(styles["arrow-icon"], className, styles[variant], styles[direction])}
      style={{
        "fontSize": size,
      }}
      icon={variant === "chevron" ? EgwWebFont["chevron-right"] : EgwWebFont["arrow-right"]}
    />
  );
};

ArrowIcon.defaultProps = {
  direction: ARROW_ICON_DIRECTION.RIGHT,
  size: "0.8rem",
  variant: "chevron"
};

ArrowIcon.direction = ARROW_ICON_DIRECTION;

ArrowIcon.propTypes = {
  active: PropTypes.bool,
  direction: PropTypes.string,
  variant: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ArrowIcon;
